import { Component } from "react";

export class CloneComponent extends Component {
  public render() {
    return this.props.children;
  }
}
